import { useReducer } from "react";

export type QueueAction =
  | { payload: { file: File; formIndex: number }; type: "ADD_TO_QUEUE" }
  | { payload: number; type: "FINISH_UPLOAD" }
  | { payload: number; type: "REMOVE_FROM_QUEUE" }
  | { payload: number; type: "START_UPLOAD" }
  | { type: "CLEAR_QUEUE" };

export interface QueueState {
  currentlyUploading: null | number;
  uploadQueue: { file: File; formIndex: number }[];
}

export const initialQueueState: QueueState = {
  currentlyUploading: null,
  uploadQueue: [],
};

export function queueReducer(
  state: QueueState,
  action: QueueAction,
): QueueState {
  switch (action.type) {
    case "ADD_TO_QUEUE": {
      if (
        !state.uploadQueue.some(
          (item) => item.formIndex === action.payload.formIndex,
        )
      ) {
        return {
          ...state,
          uploadQueue: [...state.uploadQueue, action.payload],
        };
      }

      return state;
    }
    case "START_UPLOAD": {
      return {
        ...state,
        currentlyUploading: action.payload,
        uploadQueue: state.uploadQueue.filter(
          (item) => item.formIndex !== action.payload,
        ),
      };
    }
    case "FINISH_UPLOAD": {
      return {
        ...state,
        currentlyUploading:
          state.currentlyUploading === action.payload
            ? null
            : state.currentlyUploading,
      };
    }
    case "REMOVE_FROM_QUEUE": {
      const formIndexToRemove = action.payload;

      return {
        ...state,
        currentlyUploading:
          state.currentlyUploading === formIndexToRemove
            ? null
            : state.currentlyUploading,
        uploadQueue: state.uploadQueue.filter(
          (item) => item.formIndex !== formIndexToRemove,
        ),
      };
    }
    case "CLEAR_QUEUE": {
      return initialQueueState;
    }
    default: {
      return state;
    }
  }
}

export function useUploadQueue(): [QueueState, React.Dispatch<QueueAction>] {
  return useReducer(queueReducer, initialQueueState);
}
